import { AxiosHelper } from "../axiosConfig";
import APIConstant from "../utils/apiConstant";
import {
  IKeyValue,
  ILiftOffHeader,
  ISubjectPage,
} from "../model/interface/subject";

export interface ICreateSubjectRequest {
  name: string;
  displayName?: string;
  spanishDisplayName?: string;
  subjectIcon?: string;
  notes?: string;
  contentAreaId: number;
  scoringAlgorithmId?: number | null;
  calculatorTypeId?: number | null;
  gradeLevel?: string;
  states: Array<IKeyValue>;
  grades: Array<IKeyValue>;
  liftOffHeaders?: Array<ILiftOffHeader>;
  isApproved?: boolean;
  isNWEASubject?: boolean;
  subjectTypeId: number;
}

export interface IUpdateSubjectRequest extends ICreateSubjectRequest {
  subjectId: number;
  isDeprecated?: boolean;
}

export const getSubjectAll = (
  PageSize = 10,
  PageNumber = 1,
  ColumnName = "Name",
  SortDir = "asc"
) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_SUBJECT_ALL, {
    params: {
      OrderByColumn: ColumnName,
      SortDir: SortDir,
      PageSize: PageSize,
      PageNumber: PageNumber,
      isActive: true,
      isApproved: true,
    },
  });
};

export const getSubject = (subjectData: ISubjectPage) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_SUBJECT_ALL, {
    params: {
      name: subjectData.name,
      stateId: subjectData.stateId,
      gradeId: subjectData.gradeId,
      contentAreaId: subjectData.contentAreaId,
      gradeLevel: subjectData.gradeLevel,
      pageSize: subjectData.pageSize,
      pageNumber: subjectData.pageNumber,
      orderbyColumn: subjectData.orderbyColumn,
      sortDir: subjectData.sortDir,
      isActive: subjectData.isActive,
      isApproved: subjectData.isApproved,
      SubjectId: subjectData.subjectId,
      SubjectTypeId: subjectData.subjectTypeId,
      isAlert: subjectData.isAlert,
    },
  });
};

export const getSubjectAllByContent = (contentId) => {
  return AxiosHelper.axiosInstance().get(
    APIConstant.CMS_SUBJECT_ALL_BY_CONTENTID,
    {
      params: {
        ContentAreaId: contentId,
      },
    }
  );
};

export const getSubjectDropdown = (
  OrderByColumn = "name",
  SortDir = "asc",
  PageSize = 100,
  PageNumber = 1
) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_SUBJECT_ALL, {
    params: {
      OrderByColumn: OrderByColumn,
      SortDir: SortDir,
      PageSize: PageSize,
      PageNumber: PageNumber,
    },
  });
};

export const getGradeAll = (PageSize = 10, PageNumber = 1) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_GRADE_ALL, {
    params: {
      PageSize: PageSize,
      PageNumber: PageNumber,
    },
  });
};

export const getStateAll = (PageSize: number, PageNumber: number) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_STATE, {
    params: {
      PageSize: PageSize,
      PageNumber: PageNumber,
    },
  });
};

export const getSubjectAPI = (subjectId) => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CMS_SUBJECTC_DETAIL}/${subjectId}`,
    {}
  );
};
export const getSubjectsWithMultipleStandardsAPI = (
  subjectIds: string,
  excludeVideoQuestions: boolean,
  PageNumber: number,
  PageSize: number
) => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CMS_SUBJECTC_MULTIPLE_STANDARDS}`,
    {
      params: {
        subjectIds: subjectIds,
        excludeVideoQuestions: excludeVideoQuestions,
        PageSize: PageSize,
        PageNumber: PageNumber,
      },
    }
  );
};

export const getScoringAlgorithm = () => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CMS_SUBJECT_SCORINGALGORITHM}`,
    {}
  );
};

export const getCalculators = () => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CalculatorTypes_GetAll}`,
    {}
  );
};

export const postSubjectAPI = (postSubjectData: ICreateSubjectRequest) => {
  return AxiosHelper.axiosInstance().post<number>(
    APIConstant.CMS_SUBJECT,
    postSubjectData,
    {}
  );
};
export const deleteSubjectAPI = (subjectId) => {
  return AxiosHelper.axiosInstance().delete(APIConstant.CMS_SUBJECT, {
    params: {
      id: subjectId,
    },
  });
};
export const updateSubjectAPI = (updateSubjectData: IUpdateSubjectRequest) => {
  return AxiosHelper.axiosInstance().put<number>(
    APIConstant.CMS_SUBJECT,
    updateSubjectData,
    {}
  );
};

export const getSubjectByGrade = (PageSize = 10, PageNumber = 1, GradeId) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_SUBJECT_ALL, {
    params: {
      OrderByColumn: "Name",
      SortDir: "asc",
      PageSize: PageSize,
      PageNumber: PageNumber,
      GradeId: GradeId,
      IsStandardFilter: true,
      IsActive: true,
      isApproved: true,
    },
  });
};

export const getSubjectByState = (
  PageSize = 10,
  PageNumber = 1,
  stateId,
  isActive,
  isApproved,
  gradeLevelId?
) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_SUBJECT_ALL, {
    params: {
      OrderByColumn: "Name",
      SortDir: "asc",
      PageSize: PageSize,
      PageNumber: PageNumber,
      StateId: stateId,
      isActive: isActive,
      isApproved: isApproved,
      gradeLevelId: gradeLevelId,
      isStandardFilter: true,
    },
  });
};

export const getSubjectByStateAndGrade = (
  PageSize = 10,
  PageNumber = 1,
  stateId,
  gradeId,
  subjectTypeId
) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_SUBJECT_ALL, {
    params: {
      OrderByColumn: "Name",
      SortDir: "asc",
      PageSize: PageSize,
      PageNumber: PageNumber,
      StateId: stateId,
      GradeId: gradeId,
      isActive: true,
      isApproved: true,
      SubjectTypeId: subjectTypeId,
    },
  });
};

export const getSubjectTypes = () => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_SUBJECT_TYPES, {});
};

export const createSubjectClone = (subjectId: number) => {
  return AxiosHelper.axiosInstance().post(
    `${APIConstant.CMS_SUBJECT_CLONE}/${subjectId}`
  );
};

export const uploadSubjectIcon = (uploadSubjectIcon) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_SUBJECT_ICON,
    uploadSubjectIcon,
    {}
  );
};

export const getGalaxySubjects = (stateId: number) => {
  return AxiosHelper.axiosInstance().get(
    APIConstant.CMS_GALAXY_STAR_SUBS + `?stateId=${stateId}`
  );
};

export const updateGalaxyStars = (params) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_GALAXY_STAR_SUBS_SAVE,
    params,
    {}
  );
};
